"use client";

import React from "react";
import { useMultiLanguages } from "./utils/multiLanguage/MultiLanguageContext"; 
import Link from "next/link";

const NotFound = () => {
  const { translateByCode } = useMultiLanguages();

  return (
    <div className="h-screen w-full flex flex-col justify-center items-center gap-16 p-10 md:p-20">
      <div className="flex flex-col justify-center items-center gap-7">
        <div className="text-8xl font-medium text-center">404</div>
        <div className="text-3xl font-medium text-center">
          {translateByCode("key00168")}
        </div>
        <div className="text-lg text-center">
          {translateByCode("key00169")}
        </div>
      </div>
      <Link href="/" className="cursor-pointer text-sm bg-cust-blue hover:brightness-125 px-5 py-2 rounded-xl text-white text-center transition-all duration-300 ease-in-out">
        {translateByCode("key00170")}
      </Link>
    </div>
  );
};

export default NotFound;
